import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule,ReactiveFormsModule } from '@angular/forms';
import { AgmCoreModule } from '@agm/core';
import { CommonCloudStudioModule, ENVIRONMENT, } from 'common-cloudstudio';
import { IncidentMapComponent } from './incident-map.component';
import { IncidentService } from '../services/incident.service';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { RouterModule } from '@angular/router';
import { incidentRoutes } from './incident-map.routes';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { SharedModule } from '../../shared/shared.module';
import { IncidentFormModule } from '../incident-form/incident-form.module';

declare var environment;

export function environmentFactory(): any {
  return environment;
}

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    AgmCoreModule,
    AgmCoreModule.forRoot({
      apiKey: environment.googleMapsApiKey,
      libraries: ['drawing', 'places', 'geometry']
    }),
    incidentRoutes,
    CommonCloudStudioModule,
    RouterModule.forChild([
      { path: '', component: IncidentMapComponent },
    ]),
    TooltipModule.forRoot(),
    BsDropdownModule,
    SharedModule,
    IncidentFormModule 
  ],
  declarations: [
    IncidentMapComponent
  ],
  exports: [IncidentMapComponent],
  providers: [IncidentService, { provide: ENVIRONMENT, useFactory: environmentFactory },],

})
export class IncidentMapModule { }
